import { Signal, signal } from '@angular/core';
import { ActivityEntityName } from '@jms/model';

export interface DetailRailTarget {
  entity: ActivityEntityName;
  id: string;
  operation: 'edit' | 'preview';
  params?: unknown;
}

/** Host-owned rail claim. Last `open` wins; `close` restores authored rail sections. */
export abstract class DetailSurfaceRail {

  public abstract readonly $target: Signal<DetailRailTarget | null>;
  public abstract open(target: DetailRailTarget): Promise<boolean>;
  public abstract close(): Promise<boolean>;
}

/** Last-wins rail state. Collapse/pin do not call `close()`. */
export class DetailSurfaceRailState implements DetailSurfaceRail {

  private readonly target = signal<DetailRailTarget | null>(null);

  public readonly $target = this.target.asReadonly();

  public async open(target: DetailRailTarget): Promise<boolean> {

    this.target.set(target);
    return true;
  }

  public async close(): Promise<boolean> {

    this.target.set(null);
    return true;
  }
}

/**
 * Rail head title for authored rail sections. One section (Job Item evidence): its title moves up to
 * the head and the section's own header is hidden by the host. Several sections: each keeps its
 * header, so the head carries no title — a title there would repeat the first section's.
 */
export function resolveDetailRailTitle(sections: readonly { readonly path: string; readonly title?: string }[]): string | undefined {

  const first = sections[0];
  if (!first || sections.length > 1) return undefined;
  return first.title || (first.path.endsWith('evidence') ? 'Evidence' : undefined);
}
